'use strict';

var React = require('react');
var ReactDOM = require('react-dom');
var _ = require('underscore');
var VerticalScrollBar = require('../common/VerticalScrollBar');
var appTypes = require('../../types/appTypes');
var util = require('../../helper/util');
var textHelper = util.Text;
var styleHelper = require('../../helper/styleHelper');
var propConst = require('../../constants/propConst');
var graphicsHelper = require('../../helper/graphicsHelper');

var BarItem = React.createClass({
  render: function () {
    var text = textHelper.convertSpaceToNbsp(this.props.text);
    var textStyle = {width: 'auto', color: this.props.textColor};
    if(this.props.width) {
      textStyle.width = '100%';
      textStyle.textAlign = 'center';
    }
    return (
      <div className="BarItem"
           style={this.mainCSS()}
           onClick={this.onSelClick}>
        <div ref="text" className="item-text" style={textStyle}>
          <label>
            {
              //this.props.text     //Allen:html中的空格文本会被忽略，此处装换为可显示的空格
              text
            }
          </label>
        </div>
        <canvas ref="canvas" style={{position:'absolute',zIndex:0,width:this.props.width || '100%',height:'100%'}}/>
      </div>
    );
  },

  paint : function(){
    var self = this;
    this.requestID = window.requestAnimationFrame(function() {
      var radius = self.props.radius;
      var tabStyle = self.props.tabStyle || appTypes.TAB_BAR_STYLE.LEAN;
      var strokeStyleColor = self.props.borderColor;
      var canvas = ReactDOM.findDOMNode(self.refs.canvas);
      var g = canvas.getContext('2d');
      //var w = canvas.clientWidth;
      var w = canvas.scrollWidth;
      var h = canvas.clientHeight;
      var ratio = graphicsHelper.applyDeviceRatio(g,w,h);
      var thickness = ratio;
      var offset = thickness / 2;
      w *= ratio;
      h *= ratio;
      //canvas.width = w;
      //canvas.height = h;
      //g.clearRect(0, 0, w, h);
      graphicsHelper.clearRect(g);
      g.lineWidth = thickness;
      g.strokeStyle = strokeStyleColor;
      g.strokeWidth = thickness;
      g.fillStyle = self.props.backgroundColor;
      if (tabStyle === appTypes.TAB_BAR_STYLE.LEAN) {
        if (self.props.direction === appTypes.VerticalDirection.TOP) {
          g.moveTo(offset, h + offset);
          g.lineTo(offset, radius);
          g.quadraticCurveTo(offset, offset, radius, 0);
          g.lineTo(w - 20 * ratio, offset);
          g.lineTo(w + offset, h + offset);
        } else {
          g.moveTo(offset, 0);
          g.lineTo(offset, h - radius);

          g.quadraticCurveTo(offset, h, radius, h - offset);
          g.lineTo(w - 20 * ratio, h - offset);
          g.lineTo(w, 0);
        }
        g.fill();
        g.stroke();
      } else if (tabStyle === appTypes.TAB_BAR_STYLE.SQUARE) {
        if (self.props.direction === appTypes.VerticalDirection.TOP) {
          g.moveTo(offset, h + offset);
          g.lineTo(offset, radius);
          if (radius)
            g.quadraticCurveTo(offset, offset, radius, 0);
          g.lineTo(w - radius, offset);
          if (radius)
            g.quadraticCurveTo(w, offset, w, radius);
          g.lineTo(w, h + offset);
          g.lineTo(offset, h + offset);
          g.lineTo(offset, radius);
        } else {
          g.moveTo(offset, 0);
          g.lineTo(offset, h - radius);
          if (radius)
            g.quadraticCurveTo(offset, h, radius, h);
          g.lineTo(w - radius, h);
          if (radius)
            g.quadraticCurveTo(w, h, w, h - radius);
          g.lineTo(w, 0);
        }
        g.fill();
        g.stroke();
      }
    });
  },

  mainCSS : function(){
    var css =  {
      overflow : 'hidden',
      position : 'absolute',
      width : this.props.width || 'auto',
      height : this.props.height,
      zIndex : this.props.zIndex,
      borderStyle : 'none',
      boxSizing : 'border-box',
      borderWidth : 1,
      textDecoration : 'inherit',
      lineHeight : (this.props.height) + 'px'
    };
    if(this.props.direction === appTypes.VerticalDirection.TOP){
      css.borderBottom = this.props.selected ? ('1px solid ' + this.props.backgroundColor) : '1px solid ' + this.props.borderColor;
    }else{
      css.borderTop = this.props.selected ? ('1px solid ' + this.props.backgroundColor) : '1px solid ' + this.props.borderColor;
      css.bottom = 1;
    }
    return css;
  },


  onSelClick: function (e) {
    if (this.props.onClick) {
      this.props.onClick(e,this.props.index);
    }
  },

  componentWillUnmount : function(){
    if(this.requestID){
      window.cancelAnimationFrame(this.requestID);
    }
  },

  componentDidMount: function () {
    this.adjust();
    this.paint();
  },

  componentDidUpdate : function(){
    this.paint();
  },

  adjust: function () {
    if(this.props.width) {
      return;
    }
    var txtDom = ReactDOM.findDOMNode(this.refs.text);
    var leftDom = ReactDOM.findDOMNode(this.refs.left);
    var bevelBorderDom = ReactDOM.findDOMNode(this.refs.bevelBorder);
    var bevelFillDom = ReactDOM.findDOMNode(this.refs.bevelFill);
    var selfDom = ReactDOM.findDOMNode(this);
    //var txtWidth = txtDom.clientWidth;
    var txtWidth = txtDom.scrollWidth;
    var h = selfDom.clientHeight;
    var offset = 1;
    if(h > 25){
      offset = (h-25)/150;
    }
    var width = txtWidth + 32;
    $(selfDom).css({width: width - 6});
    $(leftDom).css({width: width - 20});
    $(bevelBorderDom).css({left: width - 20});
    $(bevelFillDom).css({left: width - 20 - offset});
    $(txtDom).css({lineHeight: this.props.height + 'px', paddingLeft: 6});
    if(this.props.direction !== appTypes.VerticalDirection.TOP && this.props.tabStyle === 'csSquare'){
      $(selfDom).css({width: width - 20 + 'px'});
    }else if(this.props.direction === appTypes.VerticalDirection.TOP && this.props.tabStyle === 'csSquare'){
      $(selfDom).css({width: width - 20 + 'px'});
    }
  }
});

/***
 * 水平选项卡面板
 * @orthor mengxiaojiang
 * @createData 2016-6-15
 */
var HorizontalTabBar = React.createClass({
  getInitialState: function () {
    return {
      selectedIndex: util.Int(this.props.selectedIndex)
    }
  },

  render: function () {
    console.log(this.props);
    var txtStr;
    var tabHeight = styleHelper.getInt(this.props,propConst.TAB_HEIGHT);
    var tabWidth = styleHelper.getInt(this.props, propConst.TAB_WIDTH);
    var selIndex = this.state.selectedIndex;
    var showScrollBar = false;
    var value = 0;
    var txtColor = styleHelper.getTextColor(this.props);
    var h = styleHelper.getHeight(this.props);
    var bgColor = styleHelper.getBackgroundColor(this.props);
    var selTextColor = this.props.selectedTextColor;
    if (!_.isUndefined(this.props.verticalScrollbarShow)) {
      showScrollBar = this.props.verticalScrollbarShow;
      value = util.Int(this.props.verticalScrollbarProgress);
    }
    if (this.props.text) {
      txtStr = textHelper.delimitText(styleHelper.getText(this.props),textHelper.DM_COMMA);
    }
    return (
      <div className="component component-HorizontalTabBar">
        <div ref="bar" className="bar"
             style={{
              height : tabHeight + 1,
              fontStyle : this.props.textStyles.fontStyle,
              fontSize : this.props.textSize,
              fontWeight : this.props.textStyles.fontWeight,
              textDecoration : this.props.textStyles.textDecoration,
              fontFamily : this.props.textFontFamily,
              color : txtColor
            }}>
          {
            txtStr.map(function (itm, index) {
              return (<BarItem key={index} {...{
                width: tabWidth || 0,
                height: tabHeight,
                backgroundColor: index === selIndex ? styleHelper.getBackgroundColor(this.props) : this.props.tabColor || '#ddd',
                borderColor: this.props.borderColor,
                textColor: (index === selIndex && selTextColor !== undefined) ? selTextColor : '',
                text: itm,
                index: index,
                selected: index === selIndex,
                zIndex: index === selIndex ? (txtStr.length + 10) : (txtStr.length - index),
                onClick: this.onItemClick,
                direction : this.props.direction,
                cardPadding: this.props.tabEdge,
                tabStyle: this.props.tabStyle,
                radius: this.props.radius || 0
              }}/>)
            }, this)
          }
        </div>
        <div ref="content" style={{
          position : 'absolute',
          zIndex : 1,
          width : '100%',
          height : h - tabHeight + 1,
          top :tabHeight - 1,
          borderLeftStyle:this.props.borderVisible?'solid':'none',
          borderRightStyle:this.props.borderVisible?'solid':'none',
          borderTopStyle:this.props.borderVisible?'solid':(this.props.direction === appTypes.VerticalDirection.TOP?'solid':'none'),
          borderBottomStyle:this.props.borderVisible?'solid':(this.props.direction === appTypes.VerticalDirection.BOTTOM?'solid':'none'),
          borderWidth : 1,
          backgroundColor: styleHelper.getBackgroundColor(this.props),
          borderColor: this.props.borderColor 
        }}>
          {
            showScrollBar && (
              <VerticalScrollBar {...{value : value,right : -1,top : -1,height : h - tabHeight}}/>
            )
          }
        </div>
      </div>);
  },

  onItemClick: function (e,index) {
    this.setState({selectedIndex: index})
  },

  componentDidMount: function () {
    this.adjust();
    $(ReactDOM.findDOMNode(this)).bind('tabClick',this.onItemClick);
  },

  componentDidUpdate: function() {
    this.adjust();
  },

  adjust: function () {
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var bar = ReactDOM.findDOMNode(this.refs.bar);
    var tabH = styleHelper.getInt(this.props,propConst.TAB_HEIGHT);
    var tabW = styleHelper.getInt(this.props, propConst.TAB_WIDTH);
    var content = ReactDOM.findDOMNode(this.refs.content);
    var barItems = bar.children;
    var itemDom;
    var i;
    var tabEdge = 20;

    if(this.props.tabEdge !== undefined) {
      tabEdge = parseInt(this.props.tabEdge, 10) || 0;
    }
    var left = tabEdge;
    var itemWidth;
    var display = 'visible';
    var tabPosition = styleHelper.getPropertyValue(this.props,propConst.TAB_POSITION);
    var barWidth = 0;
    for (i = 0; i < barItems.length; i++) {
      itemDom = barItems[i];
      //itemWidth = itemDom.clientWidth;
      itemWidth = itemDom.scrollWidth;
      barWidth += (itemWidth - 15);
    }
    if(barWidth){
      barWidth += 15;
    }
    if(tabPosition === appTypes.HoriAlign.CENTER){
      left = (w - barWidth) / 2;
    }else if(tabPosition === appTypes.HoriAlign.RIGHT){
      left = w - barWidth - 28 - tabEdge;
    }
    for (i = 0; i < barItems.length; i++) {
      itemDom = barItems[i];
      //itemWidth = itemDom.clientWidth;
      itemWidth = itemDom.scrollWidth;
      if(itemDom.clientWidth !== itemWidth && tabW === 0) {
        itemWidth += 9;
      }

      display = 'visible';
      if(left < 0){
        display = 'hidden';
      }
      if(left + itemWidth > w){
        display = 'hidden';
      }
      $(itemDom).css({left: left,width: itemWidth,visibility: display});
      //left += itemDom.clientWidth - 9;
      left += itemDom.scrollWidth - 9;
      if(this.props.direction !== appTypes.VerticalDirection.TOP && this.props.tabStyle === 'csSquare'){
        left = left + 8
      }else if(this.props.direction === appTypes.VerticalDirection.TOP && this.props.tabStyle === 'csSquare'){
        left = left + 8
      }
    }
    if(this.props.direction === appTypes.VerticalDirection.TOP){
      $(bar).css({top : 0});
      $(content).css({top : tabH - 1});
    }else{
      $(bar).css({top : h - tabH + 2});
      $(content).css({top : 0});
    }
  }
});

module.exports = HorizontalTabBar;


// WEBPACK FOOTER //
// ./src/views/Components/HorizontalTabBar.jsx